import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSaveExpense() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((expense) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = expense.id
      ? quarkusApi.put('/financial/expenses', expense, authHeader)
      : quarkusApi.post('/financial/expenses', expense, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
